<template>
  <div class="container-custom">
    <!-- breadscrumbs -->
    <Breadscrumbs
      :links="[
        {
          name: 'Career',
           to: {
            name: 'CareerPage',
          }
        },
        {
          name: 'Edit',
          to: {
            name: 'CareerPageEdit',
            query: {
              section: $route.query.section,
            },
          }
        }
      ]"
    ></Breadscrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>編輯 Career Page</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">取消</button>
      <button class="btn btn-primary" @click="saveHandler">儲存</button>
    </div>

    <!-- block 2 -->
    <div class="block" v-if="career">
      <PageMenu :sections="sections">
        <component :is="sectionView" style="min-height: 800px;" :career="career"></component>
      </PageMenu>
    </div>

        <!-- page-actions -->
    <div class="page-actions">
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">取消</button>
      <button class="btn btn-primary" @click="saveHandler">儲存</button>
    </div>
    <LangDialog :isOpen.sync="isLangOpen" @confirm-submit="saveHandler"></LangDialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import PageMenu from '@/components/PageMenu.vue';

import MainMessaging from '@/views/B-5__CareerPage/c/B-5-1-1__CareerEdit_MainMessaging.vue';
import CompanyCulture from '@/views/B-5__CareerPage/c/B-5-2-1__CareerEdit_CompanyCulture.vue';
import DepartmentTeams from '@/views/B-5__CareerPage/c/B-5-3-1__CareerEdit_Departments.vue';
import JobInformation from '@/views/B-5__CareerPage/c/B-5-4-1__CareerEdit_CareerJobInformation.vue';
import VideoRotate from '@/views/B-5__CareerPage/c/B-5-5-1__CareerEdit_VideoRotate.vue';
import LangDialog from '@/components/LangSubmitDialog.vue';
import Breadscrumbs from '@/components/Breadscrumbs.vue';

export default {
  components: {
    PageMenu,
    MainMessaging,
    CompanyCulture,
    DepartmentTeams,
    JobInformation,
    VideoRotate,
    LangDialog,
    Breadscrumbs,
  },
  data: () => ({
    isLangOpen: false,
    sections: [
      { name: 'Main Messaging', component: 'MainMessaging' },
      { name: 'Company Culture', component: 'CompanyCulture' },
      { name: 'Departments & Teams', component: 'DepartmentTeams' },
      { name: 'Job Information', component: 'JobInformation' },
      { name: 'Video Rotate', component: 'VideoRotate' },
    ],
  }),
  computed: {
    ...mapState(['lang']),
    ...mapState('career', ['career']),
    sectionIndex() {
      const vm = this;
      return vm.$route.query.section || 0;
    },
    sectionView() {
      const vm = this;
      return vm.sections[vm.sectionIndex].component;
    },
  },
  async created() {
    if (this.career === null) {
      await this.getCareer();
    }
  },
  methods: {
    ...mapActions('career', {
      getCareer: 'find',
      save: 'save',
      clear: 'clear',
    }),
    toCareerPage() {
      this.$router.push({
        name: 'CareerPage',
        query: {
          section: this.$route.query.section,
        },
      });
    },
    cancelHandler() {
      this.toCareerPage();
    },
    saveHandler() {
      if (this.isLangOpen || !this.lang.id) {
        this.save(this.career).then(() => {
          this.toCareerPage();
          this.clear();
        });
      } else {
        this.isLangOpen = true;
      }
    },
  },
};
</script>

<style></style>
